<template>
  <base-page>
    <titlu-pagina Titlu="Semnatura" :AdaugaVisible="false"></titlu-pagina>
    <div class="editor">
      <el-upload
        class="avatar-uploader"
        :action="baseUrl + '/Semnaturi/upload_semnatura?id=' + User.Id"
        :show-file-list="false"
        name="imagine"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div class="btn-group">
        <el-button type="danger" @click="clear()">Sterge</el-button>
        <!-- <el-button type="success" @click="save()">Salveaza</el-button> -->
      </div>
    </div>
  </base-page>
</template>

<script>
import settings from "../../backend/LocalSettings";
import BasePage from "../../pages/Admin/BasePage";
import TitluPagina from "../../widgets/TitluPagina";


export default {
  name: "dashboard",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      editor: null,
      imageUrl: "",
      baseUrl: '',
      User: {}
    };
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("Semnatura trebuie sa fie in format JPG!");
      }
      if (!isLt2M) {
        this.$message.error("Semnatura nu poate sa depaseasca 2MB!");
      }
      return isJPG && isLt2M;
    },

    clear: async function () {
        if (this.imageUrl === "" || this.imageUrl.length <= 0) return;
        this.imageUrl = "";
        let res = await this.$http.post('Semnaturi/delete_semnatura');
    },
    save: async function () {
      
    },
    async get_user(){
      let res = await this.$http.post('Semnaturi/get_user');
      this.User = res.body.User;
      // console.log(res);
    },
    async get_semnatura(){
      let res = await this.$http.post('Semnaturi/get_semnatura');
      this.imageUrl = res.body.Semnatura;
      // console.log(res);
    }
  },
  mounted() {
    if (!this.$has_right('Management') && !this.$has_right('Supervizor')){
      this.$router.push('/no-rights')
      return
    }
    this.baseUrl = settings.BASE_URL;
    this.get_user();
    this.get_semnatura();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.tag-logged {
  font-size: 12px;
  opacity: 0.5;
}

.editor {
  background-color: #fff;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  flex-direction: column;
}
.avatar-uploader {
  border: 1px dotted #8c939d;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  margin: 10px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.sign-pad {
  margin-left: auto;
  margin-right: auto;
}

.btn-group {
  margin: 10px;
  margin-left: auto;
  margin-right: auto;
}
</style>
